module.exports = __webpack_public_path__ + "img/enotas.9da179a5.svg";